<template>
  <div class="modal">
    <div class="modal-window">
      <span class="close" @click="$emit('close')">
        <font-awesome-icon icon="times"/>
      </span>
      <div class="text">
        В данной группе не добавлено ни одного теста.
      </div>
    </div>
    <div class="modal-window">
      <span class="close" @click="$emit('close')">
        <font-awesome-icon icon="times"/>
      </span>
      <div class="top-line text">
        Данный пользователь не добавлен ни в одну группу. <br> <span style="font-weight: 400">Обратитесь к администратору.</span>
      </div>
      <div>
        <button class="btn" @click="$emit('close')" type="button">Закрыть</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotificationModal'
}
</script>

<style scoped lang="scss">
  span.close {
    position: absolute;
    right: 30px;
    top: 20px;
    cursor: pointer;
  }

  .text {
    font-size: 22px;
    font-weight: 300;
  }

  .btn {
    padding-top: 15px;
    padding-bottom: 15px;
    font-size: 18px;
    margin: 0 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/modal/NotificationModal.vue